import { Box, Flex, Grid, Icon, Text } from '@chakra-ui/react';
import { SanitizedText } from '@/ui/SanitizedDom';
import { Loader } from '@/design-system/loader';
import { getIcon } from '../view';
import { getDelayById } from '@/pages/mco/steps/components/step/delay';
import { useGetStepByIdQuery } from '@/store/query/mco-step';
import { AttachmentPreview } from '@/components/outreach-attachment/AttachmentPreview';

export const StepPreview = ({ step = {}, onClose = () => {}, blueprint }) => {
  const { data, isLoading } = useGetStepByIdQuery(
    {
      outreachId: blueprint?.outreach?.id,
      stepId: step?.id,
    },
    { skip: !step?.id || !blueprint?.outreach?.id }
  );
  const stepInterval = getDelayById(step?.step_interval);
  return (
    <Box
      cursor="pointer"
      borderWidth="1px"
      borderColor="border-color"
      bg="white"
      borderRadius="12px"
    >
      <Flex
        p="12px 24px"
        borderRadius="12px 12px 0 0"
        bg="rgba(155, 155, 155, 0.1)"
        borderBottomColor="#E5E5E5"
        borderBottomWidth="1px"
        h="60px"
        alignItems="center"
      >
        <Flex alignItems="center" width="300px">
          <Icon
            width="36px"
            height="36px"
            as={getIcon(step?.channel)}
            borderRadius="8px"
          />
          <Text fontSize="16px" fontWeight="semiBold" ml="12px">
            Step 1 :
          </Text>
          <Text fontSize="14px" ml="4px" flex="1">
            {step?.name}
          </Text>
        </Flex>
        <Box width="200px">
          <Text>{step?.mode === 'auto' ? 'Automatic' : 'Manual'}</Text>
        </Box>
        <Flex flex="1">
          <Text textAlign="center" fontWeight="semiBold">
            Schedule in:
          </Text>
          <Text textAlign="center" ml="6px">
            {stepInterval?.label}
          </Text>
        </Flex>
        <Box width="50px">
          <Text color="#0043CE" onClick={onClose} fontWeight="medium">
            Close
          </Text>
        </Box>
      </Flex>
      <Box>
        {isLoading ? (
          <Flex h="300px" alignItems="center" justifyContent="center">
            <Loader />
          </Flex>
        ) : (
          <>
            <Flex
              h="50px"
              alignItems="center"
              px="24px"
              borderBottomWidth="1px"
              borderColor="border-color"
            >
              <Text fontWeight="semiBold" mr="8px">
                Subject:
              </Text>
              <Text> {data?.template?.subject}</Text>
            </Flex>
            <Box
              p="24px"
              fontSize="14px"
              className="editor-style"
              minHeight="100px"
              maxHeight="300px"
              overflow="auto"
            >
              <SanitizedText
                whiteSpace="pre-wrap"
                variant="muted"
                html={data?.template?.body}
              />
            </Box>
            {data?.template?.attachments.length > 0 && (
              <Grid
                p="24px"
                gap="10px"
                borderTop="1px solid #E5E5E5 "
                templateColumns="repeat(3, 1fr)"
              >
                {data?.template?.attachments?.map((file, idx) => (
                  <AttachmentPreview key={idx} file={file} />
                ))}
              </Grid>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};
